import { render, staticRenderFns } from "./WidgetSettingsRenderer.vue?vue&type=template&id=08a176c1&"
import script from "./WidgetSettingsRenderer.vue?vue&type=script&lang=js&"
export * from "./WidgetSettingsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports